var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:_vm.theClass,style:(_vm.theStyle),attrs:{"aria-label":_vm.theTitle}},[(
      _vm.statistic.statisticDefinition.ci &&
      _vm.statistic.value !== undefined &&
      !_vm.statistic.isSampleSizeIsTooLow &&
      !_vm.statistic.isRelativeStandardErrorTooHigh &&
      !_vm.statistic.isMissing
    )?[_vm._v(" "+_vm._s(_vm.statistic.formattedCi)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }